import React, { useState } from "react";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { AvatarApi } from "services/avatar";
import { RoleUpdateModalBody } from "styled_components/Account/RoleUpdateModalBody";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";

export default function RoleModal({
  show,
  closeModal,
  user,
  owners,
  updateUserRole,
  breakpoint,
  getSize,
}) {
  const [role, setRole] = useState(null);
  function getHeader() {
    const avatarApi = new AvatarApi();
    return (
      <ModalHeader
        image={avatarApi.getGenericAvatar()}
        text={"Here you can change a users role."}
      />
    );
  }

  function handleRoleChange() {
    updateUserRole(role);
    setRole(null);
  }

  return (
    <PortraitModalComponent
      closeModal={closeModal}
      show={show}
      header={getHeader()}
      subTitle={"Select the role below."}
      title="Role Change"
      size={getSize(breakpoint)}
      breakpoint={breakpoint}
      customClassName={"role"}
    >
      <RoleUpdateModalBody
        user={user}
        owners={owners}
        role={role}
        setRole={setRole}
        text={`Please confirm you want to change ${user?.firstname} ${user?.lastname}'s role.`}
      />
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={"Confirm"}
        buttonText2="Back"
        buttonActive1={role !== null}
        buttonActive2={true}
        module="account"
        buttonFunction1={handleRoleChange}
        size={getSize(breakpoint)}
      />
    </PortraitModalComponent>
  );
}
